// Webpack entry point for module federation.
import("./config.js");
